@if (laboratory() && !getExperimentError()) {
  <div id="set-parameters--container">
    <div id="header--container">
      <h4>
        @if (!createdExperiment()) {
          <span>New Experiment Setup</span>
        }
        @if (createdExperiment()) {
          <span>
            {{ createdExperiment()?.name }}
            <app-status-indicator
              [status]="
                ExperimentStatus[createdExperiment()?.experimentStatusId]
              "
            ></app-status-indicator>
          </span>
        }
      </h4>
      <h5>{{ laboratory()?.laboratoryName }}</h5>
    </div>
    <hr />
    <div id="inner-page--container">
      <mat-accordion>
        <mat-expansion-panel [expanded]="true" hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="expansion-header">Experiment Details</div>
              @if (createdExperiment()) {
                <app-mat-icon-button
                  buttonStyle="negative"
                  buttonId="delete-btn"
                  ariaLabel="Delete experiment draft"
                  iconName="delete"
                  (buttonClicked)="openModal('delete-draft')"
                  [isDisabled]="
                    isProcessing() ||
                    deleteIsProcessing() ||
                    !(currentUser().role | roleCheck: labAdminRoles)
                  "
                  (click)="$event.stopPropagation()"
                ></app-mat-icon-button>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mode-module--container">
            <div class="select--container">
              <div class="template-field--container">
                @if (fetchTemplatesLoading()) {
                  <div>
                    <app-small-loading-spinner></app-small-loading-spinner>
                  </div>
                } @else if (fetchTemplatesError()) {
                  <div class="error body2" role="alert" aria-live="assertive">
                    Error: Unable to fetch templates.
                    <app-underlined-text-button
                      label="Retry"
                      ariaLabel="Retry loading experiment templates"
                      (buttonClicked)="getExperimentTemplates()"
                    ></app-underlined-text-button>
                  </div>
                } @else {
                  <app-underlined-dropdown-form-field
                    [parentForm]="experimentTemplateForm"
                    [field]="experimentTemplatesField"
                  ></app-underlined-dropdown-form-field>
                }
              </div>
            </div>
            <app-chip-radio-button
              id="toggle--container"
              [field]="experimentModeField"
              [parentForm]="experimentControlsForm"
              [currentValue]="
                experimentControlsForm?.controls[experimentModeField.key]?.value
              "
              (radioButtonChange)="
                handleExperimentModeChange(
                  experimentControlsForm?.controls[experimentModeField.key]
                    ?.value
                )
              "
            ></app-chip-radio-button>
            <app-chip-checkbox-group
              id="module-select"
              [parentForm]="moduleSelectForm"
              [field]="moduleCheckboxesField"
              (checkboxClicked)="moduleCheckboxClicked($event)"
              checkboxStyle="tabs"
              [isDisabled]="draftIsLocked()"
            ></app-chip-checkbox-group>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      <div class="accordion-controls">
        <button type="button" (click)="accordion.openAll()">Expand all</button>
        <div aria-hidden="true">|</div>
        <button type="button" (click)="accordion.closeAll()">
          Collapse all
        </button>
      </div>
      <form (ngSubmit)="handleSubmit()">
        <mat-accordion multi #accordion="matAccordion">
          <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">Experiment Controls</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="notifications--container">
              <div class="notifications">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="enableNotificationsField"
                  [tooltipText]="notificationTooltip"
                ></app-slide-toggle>
                <div class="select--container">
                  <div class="notification-field--container">
                    @if (labMemembersDropdownLoading()) {
                      <div>
                        <app-small-loading-spinner></app-small-loading-spinner>
                      </div>
                    } @else if (getLabUsersError()) {
                      <div
                        class="error body2"
                        role="alert"
                        aria-live="assertive"
                      >
                        Error: Unable to fetch laboratory users.
                        <app-underlined-text-button
                          label="Retry"
                          ariaLabel="Retry loading laboratory users"
                          (buttonClicked)="getLabMembers()"
                        ></app-underlined-text-button>
                      </div>
                    } @else {
                      <app-underlined-dropdown-form-field
                        [parentForm]="experimentControlsForm"
                        [field]="notificationEmailField"
                      ></app-underlined-dropdown-form-field>
                    }
                  </div>
                </div>
              </div>
              @if (
                !experimentControlsForm.get(notificationEmailField.key)
                  ?.disabled
              ) {
                <div class="body1">
                  {{ selectedNotificationUser()?.firstName }}
                  {{ selectedNotificationUser()?.lastName }}:
                  {{ selectedNotificationUser()?.role | formatRole }}
                </div>
              }
            </div>
            <div class="underlined-form-field-grid">
              <app-underlined-form-field
                [parentForm]="experimentControlsForm"
                [field]="experimentNameField"
              ></app-underlined-form-field>
              <app-underlined-form-field
                [parentForm]="experimentControlsForm"
                [field]="organismField"
              ></app-underlined-form-field>
              <app-underlined-form-field
                [parentForm]="experimentControlsForm"
                [field]="strainField"
              ></app-underlined-form-field>
              <app-underlined-form-field
                [parentForm]="experimentControlsForm"
                [field]="mediaField"
              ></app-underlined-form-field>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">Base Unit</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="base-unit-time-grid">
              <app-number-form-field
                [parentForm]="experimentControlsForm"
                [field]="samplingTimeField"
                [minValue]="minSampleTimeInMins"
                [maxValue]="maxSampleTimeInMins"
                [step]="sampleTimeStep"
                [labelAbove]="true"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="experimentControlsForm"
                [field]="experimentTimeField"
                [minValue]="minExperimentTimeInHours"
                [maxValue]="maxExperimentTimeInHours"
                [step]="experimentTimeStep"
                [labelAbove]="true"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="experimentControlsForm"
                [field]="ambientTemperatureField"
                [minValue]="minAmbientTemp"
                [maxValue]="maxAmbientTemp"
                [step]="ambientTempStep"
                [showWarning]="isAmbientTemperatureInWarningRange()"
                [warningMessage]="getAmbientTemperatureInWarningRange()"
                [labelAbove]="true"
              ></app-number-form-field>
            </div>
            <div class="card-grid">
              <div class="button-header">
                <div class="grey-label">FLASK TEMPERATURE CONTROLS</div>
                <app-mat-outlined-button
                  label="Copy A to B, C, D"
                  ariaLabel="Copy A to B, C, D"
                  buttonId="temp-controls-copy-btn"
                  id="temp-controls-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyTempControlValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="temperatureControlAField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="temperatureAField"
                  [minValue]="minCultureTemp"
                  [maxValue]="maxCultureTemp"
                  [step]="cultureTempStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="temperatureControlBField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="temperatureBField"
                  [minValue]="minCultureTemp"
                  [maxValue]="maxCultureTemp"
                  [step]="cultureTempStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="temperatureControlCField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="temperatureCField"
                  [minValue]="minCultureTemp"
                  [maxValue]="maxCultureTemp"
                  [step]="cultureTempStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="temperatureControlDField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="temperatureDField"
                  [minValue]="minCultureTemp"
                  [maxValue]="maxCultureTemp"
                  [step]="cultureTempStep"
                ></app-number-form-field>
              </div>
            </div>
            <div class="card-grid">
              <div class="button-header">
                <div class="grey-label">STIRRING SPEED CONTROLS</div>
                <app-mat-outlined-button
                  label="Copy A to B, C, D"
                  ariaLabel="Copy A to B, C, D"
                  buttonId="stirring-speed-copy-btn"
                  id="stirring-speed-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyStirringSpeedValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="setStirringSpeedAField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="speedAField"
                  [minValue]="minSpeed"
                  [maxValue]="maxSpeed"
                  [step]="speedStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="setStirringSpeedBField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="speedBField"
                  [minValue]="minSpeed"
                  [maxValue]="maxSpeed"
                  [step]="speedStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="setStirringSpeedCField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="speedCField"
                  [minValue]="minSpeed"
                  [maxValue]="maxSpeed"
                  [step]="speedStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="setStirringSpeedDField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="speedDField"
                  [minValue]="minSpeed"
                  [maxValue]="maxSpeed"
                  [step]="speedStep"
                ></app-number-form-field>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            [expanded]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value === ExperimentMode.Turbidostat
            "
            [disabled]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value !== ExperimentMode.Turbidostat
            "
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">Turbidostat</div>
              </mat-panel-title>
              @if (
                experimentControlsForm?.controls[experimentModeField.key]
                  ?.value !== ExperimentMode.Turbidostat
              ) {
                <mat-panel-description>Mode not selected</mat-panel-description>
              }
            </mat-expansion-panel-header>
            <div class="card-grid">
              <div class="button-header">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="maintainODField"
                ></app-slide-toggle>
                <app-mat-outlined-button
                  label="Copy A to B, C, D"
                  ariaLabel="Copy A to B, C, D"
                  buttonId="turbidostat-copy-btn"
                  id="turbidostat-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyTurbidostatControlValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="turbAActiveField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="targetODAField"
                  [minValue]="minTargetOD"
                  [maxValue]="maxTargetOD"
                  [step]="targetODStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="turbBActiveField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="targetODBField"
                  [minValue]="minTargetOD"
                  [maxValue]="maxTargetOD"
                  [step]="targetODStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="turbCActiveField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="targetODCField"
                  [minValue]="minTargetOD"
                  [maxValue]="maxTargetOD"
                  [step]="targetODStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="turbDActiveField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="targetODDField"
                  [minValue]="minTargetOD"
                  [maxValue]="maxTargetOD"
                  [step]="targetODStep"
                ></app-number-form-field>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            [expanded]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value === ExperimentMode.Chemostat
            "
            [disabled]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value !== ExperimentMode.Chemostat
            "
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">Chemostat</div>
              </mat-panel-title>
              @if (
                experimentControlsForm?.controls[experimentModeField.key]
                  ?.value !== ExperimentMode.Chemostat
              ) {
                <mat-panel-description>Mode not selected</mat-panel-description>
              }
            </mat-expansion-panel-header>
            <div class="card-grid">
              <div class="button-header">
                <app-mat-outlined-button
                  label="Copy A to B, C, D"
                  ariaLabel="Copy A to B, C, D"
                  buttonId="chemostat-copy-btn"
                  id="chemostat-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyChemostatControlValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="chemoAActiveField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="flowRateAField"
                  [minValue]="minFlowRate"
                  [maxValue]="maxFlowRate"
                  [step]="flowRateStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="chemoBActiveField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="flowRateBField"
                  [minValue]="minFlowRate"
                  [maxValue]="maxFlowRate"
                  [step]="flowRateStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="chemoCActiveField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="flowRateCField"
                  [minValue]="minFlowRate"
                  [maxValue]="maxFlowRate"
                  [step]="flowRateStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="chemoDActiveField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="flowRateDField"
                  [minValue]="minFlowRate"
                  [maxValue]="maxFlowRate"
                  [step]="flowRateStep"
                ></app-number-form-field>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            [expanded]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value === ExperimentMode.PHControl
            "
            [disabled]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value !== ExperimentMode.PHControl
            "
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">pH Control</div>
              </mat-panel-title>
              @if (
                experimentControlsForm?.controls[experimentModeField.key]
                  ?.value !== ExperimentMode.PHControl
              ) {
                <mat-panel-description>Mode not selected</mat-panel-description>
              }
            </mat-expansion-panel-header>
            <div class="ph-grid">
              <div class="button-header">
                <app-mat-outlined-button
                  label="Copy A to B, C, D"
                  ariaLabel="Copy A to B, C, D"
                  buttonId="ph-copy-btn"
                  id="ph-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyPHValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="phControlAField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="targetPHAField"
                    [minValue]="minTargetPH"
                    [maxValue]="maxTargetPH"
                    [step]="targetPHStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="pumpDurationAField"
                    [minValue]="minPumpDuration"
                    [maxValue]="maxPumpDuration"
                    [step]="pumpDurationStep"
                  ></app-number-form-field>
                  <app-radio-button
                    id="ph-radio-a"
                    [field]="inputTypeAField"
                    [parentForm]="experimentControlsForm"
                    [currentValue]="
                      experimentControlsForm?.controls[inputTypeAField.key]
                        ?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                </div>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="phControlBField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="targetPHBField"
                    [minValue]="minTargetPH"
                    [maxValue]="maxTargetPH"
                    [step]="targetPHStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="pumpDurationBField"
                    [minValue]="minPumpDuration"
                    [maxValue]="maxPumpDuration"
                    [step]="pumpDurationStep"
                  ></app-number-form-field>
                  <app-radio-button
                    id="ph-radio-b"
                    [field]="inputTypeBField"
                    [parentForm]="experimentControlsForm"
                    [currentValue]="
                      experimentControlsForm?.controls[inputTypeBField.key]
                        ?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                </div>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="phControlCField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="targetPHCField"
                    [minValue]="minTargetPH"
                    [maxValue]="maxTargetPH"
                    [step]="targetPHStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="pumpDurationCField"
                    [minValue]="minPumpDuration"
                    [maxValue]="maxPumpDuration"
                    [step]="pumpDurationStep"
                  ></app-number-form-field>
                  <app-radio-button
                    id="ph-radio-c"
                    [field]="inputTypeCField"
                    [parentForm]="experimentControlsForm"
                    [currentValue]="
                      experimentControlsForm?.controls[inputTypeCField.key]
                        ?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                </div>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="phControlDField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="targetPHDField"
                    [minValue]="minTargetPH"
                    [maxValue]="maxTargetPH"
                    [step]="targetPHStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="pumpDurationDField"
                    [minValue]="minPumpDuration"
                    [maxValue]="maxPumpDuration"
                    [step]="pumpDurationStep"
                  ></app-number-form-field>
                  <app-radio-button
                    id="ph-radio-d"
                    [field]="inputTypeDField"
                    [parentForm]="experimentControlsForm"
                    [currentValue]="
                      experimentControlsForm?.controls[inputTypeDField.key]
                        ?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            [expanded]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value === ExperimentMode.PHControlDouble
            "
            [disabled]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value !== ExperimentMode.PHControlDouble
            "
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">BETA: pH 2xControl</div>
              </mat-panel-title>
              @if (
                experimentControlsForm?.controls[experimentModeField.key]
                  ?.value !== ExperimentMode.PHControlDouble
              ) {
                <mat-panel-description>Mode not selected</mat-panel-description>
              }
            </mat-expansion-panel-header>
            <div class="ph-grid">
              <div class="button-header">
                <app-mat-outlined-button
                  label="Copy A to B"
                  ariaLabel="Copy A to B"
                  buttonId="ph-double-copy-btn"
                  id="ph-double-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyPHDoubleValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="ph2ControlAField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="targetPH2AField"
                    [minValue]="minTargetPH"
                    [maxValue]="maxTargetPH"
                    [step]="targetPHStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="pumpDuration2AField"
                    [minValue]="minPumpDuration"
                    [maxValue]="maxPumpDuration"
                    [step]="pumpDurationStep"
                  ></app-number-form-field>
                </div>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="ph2ControlBField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="targetPH2BField"
                    [minValue]="minTargetPH"
                    [maxValue]="maxTargetPH"
                    [step]="targetPHStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="pumpDuration2BField"
                    [minValue]="minPumpDuration"
                    [maxValue]="maxPumpDuration"
                    [step]="pumpDurationStep"
                  ></app-number-form-field>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            [expanded]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value === ExperimentMode.PHControlChemostat
            "
            [disabled]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value !== ExperimentMode.PHControlChemostat
            "
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">BETA: pH + Chemostat</div>
              </mat-panel-title>
              @if (
                experimentControlsForm?.controls[experimentModeField.key]
                  ?.value !== ExperimentMode.PHControlChemostat
              ) {
                <mat-panel-description>Mode not selected</mat-panel-description>
              }
            </mat-expansion-panel-header>
            <div class="ph-grid">
              <div class="button-header">
                <app-mat-outlined-button
                  label="Copy A to B"
                  ariaLabel="Copy A to B"
                  buttonId="ph-chemostat-copy-btn"
                  id="ph-chemostat-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyPHChemostatValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="phChemoControlAField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="targetPHChemoAField"
                    [minValue]="minTargetPH"
                    [maxValue]="maxTargetPH"
                    [step]="targetPHStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="pumpDurationChemoAField"
                    [minValue]="minPumpDuration"
                    [maxValue]="maxPumpDuration"
                    [step]="pumpDurationStep"
                  ></app-number-form-field>
                  <app-radio-button
                    id="ph-chemo-radio-a"
                    [field]="inputTypeChemoAField"
                    [parentForm]="experimentControlsForm"
                    [currentValue]="
                      experimentControlsForm?.controls[inputTypeChemoAField.key]
                        ?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="flowRatePHAField"
                    [minValue]="minFlowRate"
                    [maxValue]="maxFlowRate"
                    [step]="flowRateStep"
                  ></app-number-form-field>
                </div>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="phChemoControlBField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="targetPHChemoBField"
                    [minValue]="minTargetPH"
                    [maxValue]="maxTargetPH"
                    [step]="targetPHStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="pumpDurationChemoBField"
                    [minValue]="minPumpDuration"
                    [maxValue]="maxPumpDuration"
                    [step]="pumpDurationStep"
                  ></app-number-form-field>
                  <app-radio-button
                    id="ph-chemo-radio-b"
                    [field]="inputTypeChemoBField"
                    [parentForm]="experimentControlsForm"
                    [currentValue]="
                      experimentControlsForm?.controls[inputTypeChemoBField.key]
                        ?.value
                    "
                    legendStyle="small"
                    size="small"
                  ></app-radio-button>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="flowRatePHBField"
                    [minValue]="minFlowRate"
                    [maxValue]="maxFlowRate"
                    [step]="flowRateStep"
                  ></app-number-form-field>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            [expanded]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value === ExperimentMode.Morbidostat
            "
            [disabled]="
              experimentControlsForm?.controls[experimentModeField.key]
                ?.value !== ExperimentMode.Morbidostat
            "
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">BETA: Morbidostat</div>
              </mat-panel-title>
              @if (
                experimentControlsForm?.controls[experimentModeField.key]
                  ?.value !== ExperimentMode.Morbidostat
              ) {
                <mat-panel-description>Mode not selected</mat-panel-description>
              }
            </mat-expansion-panel-header>
            <div class="button-header">
              <div class="warning">
                <mat-icon>warning</mat-icon>
                <p>Warning: Requires external pump module</p>
              </div>
              <app-mat-outlined-button
                label="Copy A to B, C, D"
                ariaLabel="Copy A to B, C, D"
                buttonId="morbidostat-copy-btn"
                id="morbidostat-copy-btn"
                iconName="content_copy"
                iconPosition="left"
                (buttonClicked)="copyMorbidostatValues()"
                [isDisabled]="
                  !(currentUser().role | roleCheck: editAccessRoles)
                "
              ></app-mat-outlined-button>
            </div>
            <div class="ph-grid">
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="morbidostatAActiveField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="thresholdODAField"
                    [minValue]="minThreshold"
                    [maxValue]="maxThreshold"
                    [step]="thresholdStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="dilutionPeriodAField"
                    [minValue]="minDilutionPeriod"
                    [maxValue]="maxDilutionPeriod"
                    [step]="dilutionPeriodStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="dilutionFactorAField"
                    [minValue]="minDilutionFactor"
                    [maxValue]="maxDilutionFactor"
                    [step]="dilutionFactorStep"
                  ></app-number-form-field>
                </div>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="morbidostatBActiveField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="thresholdODBField"
                    [minValue]="minThreshold"
                    [maxValue]="maxThreshold"
                    [step]="thresholdStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="dilutionPeriodBField"
                    [minValue]="minDilutionPeriod"
                    [maxValue]="maxDilutionPeriod"
                    [step]="dilutionPeriodStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="dilutionFactorBField"
                    [minValue]="minDilutionFactor"
                    [maxValue]="maxDilutionFactor"
                    [step]="dilutionFactorStep"
                  ></app-number-form-field>
                </div>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="morbidostatCActiveField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="thresholdODCField"
                    [minValue]="minThreshold"
                    [maxValue]="maxThreshold"
                    [step]="thresholdStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="dilutionPeriodCField"
                    [minValue]="minDilutionPeriod"
                    [maxValue]="maxDilutionPeriod"
                    [step]="dilutionPeriodStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="dilutionFactorCField"
                    [minValue]="minDilutionFactor"
                    [maxValue]="maxDilutionFactor"
                    [step]="dilutionFactorStep"
                  ></app-number-form-field>
                </div>
              </div>
              <div class="ph-card">
                <div class="toggle">
                  <app-slide-toggle
                    [parentForm]="experimentControlsForm"
                    [field]="morbidostatDActiveField"
                  ></app-slide-toggle>
                </div>
                <div class="fields">
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="thresholdODDField"
                    [minValue]="minThreshold"
                    [maxValue]="maxThreshold"
                    [step]="thresholdStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="dilutionPeriodDField"
                    [minValue]="minDilutionPeriod"
                    [maxValue]="maxDilutionPeriod"
                    [step]="dilutionPeriodStep"
                  ></app-number-form-field>
                  <app-number-form-field
                    [parentForm]="experimentControlsForm"
                    [field]="dilutionFactorDField"
                    [minValue]="minDilutionFactor"
                    [maxValue]="maxDilutionFactor"
                    [step]="dilutionFactorStep"
                  ></app-number-form-field>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel
            [expanded]="useOxygen()"
            [disabled]="!useOxygen()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">Oxygen</div>
              </mat-panel-title>
              @if (!useOxygen()) {
                <mat-panel-description
                  >Module not selected</mat-panel-description
                >
              }
            </mat-expansion-panel-header>
            <div class="oxygen-grid">
              <div class="button-header">
                <app-mat-outlined-button
                  label="Copy A to B, C, D"
                  ariaLabel="Copy A to B, C, D"
                  buttonId="oxygen-copy-btn"
                  id="oxygen-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyOxygenValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <app-number-form-field
                [parentForm]="experimentControlsForm"
                [field]="salinityAField"
                [minValue]="minSalinity"
                [maxValue]="maxSalinity"
                [step]="salinityStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="experimentControlsForm"
                [field]="salinityBField"
                [minValue]="minSalinity"
                [maxValue]="maxSalinity"
                [step]="salinityStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="experimentControlsForm"
                [field]="salinityCField"
                [minValue]="minSalinity"
                [maxValue]="maxSalinity"
                [step]="salinityStep"
              ></app-number-form-field>
              <app-number-form-field
                [parentForm]="experimentControlsForm"
                [field]="salinityDField"
                [minValue]="minSalinity"
                [maxValue]="maxSalinity"
                [step]="salinityStep"
              ></app-number-form-field>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel [expanded]="useFluorescence()">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">Fluorescence</div>
              </mat-panel-title>
              @if (!useFluorescence()) {
                <mat-panel-description>
                  <div id="fluorescence-warning">
                    Module not selected for fluorescence measurement (LED
                    controls still available)
                    <span class="body2"
                      >Fluorescence settings will only apply if the device has
                      the module installed</span
                    >
                  </div>
                </mat-panel-description>
              }
            </mat-expansion-panel-header>
            <div class="card-grid">
              <div class="button-header">
                <div class="grey-label">LED CONTROLS</div>
                <app-mat-outlined-button
                  label="Copy 1 to 2, 3"
                  ariaLabel="Copy 1 to 2, 3"
                  buttonId="led-copy-btn"
                  id="led-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyLEDValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="led1OnField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="led1IntensityField"
                  [minValue]="minLEDIntensity"
                  [maxValue]="maxLEDIntensity"
                  [step]="ledIntensityStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="led2OnField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="led2IntensityField"
                  [minValue]="minLEDIntensity"
                  [maxValue]="maxLEDIntensity"
                  [step]="ledIntensityStep"
                ></app-number-form-field>
              </div>
              <div class="card">
                <app-slide-toggle
                  [parentForm]="experimentControlsForm"
                  [field]="led3OnField"
                ></app-slide-toggle>
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="led3IntensityField"
                  [minValue]="minLEDIntensity"
                  [maxValue]="maxLEDIntensity"
                  [step]="ledIntensityStep"
                ></app-number-form-field>
              </div>
            </div>
            <div class="card-grid">
              <div class="button-header">
                <div class="grey-label">INTEGRATION TIME & GAIN</div>
                <app-mat-outlined-button
                  label="Copy A to B, C, D"
                  ariaLabel="Copy A to B, C, D"
                  buttonId="integration-time-copy-btn"
                  id="integration-time-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copyIntegrationTimeValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <div class="card">
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="integrationTimeAField"
                  [minValue]="minIntegrationTime"
                  [maxValue]="maxIntegrationTime"
                  [step]="integrationTimeStep"
                ></app-number-form-field>
                <app-radio-button
                  id="gain-radio-a"
                  [field]="specGainAField"
                  [parentForm]="experimentControlsForm"
                  [currentValue]="
                    experimentControlsForm?.controls[specGainAField.key]?.value
                  "
                  legendStyle="small"
                  size="small"
                ></app-radio-button>
              </div>
              <div class="card">
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="integrationTimeBField"
                  [minValue]="minIntegrationTime"
                  [maxValue]="maxIntegrationTime"
                  [step]="integrationTimeStep"
                ></app-number-form-field>
                <app-radio-button
                  id="gain-radio-b"
                  [field]="specGainBField"
                  [parentForm]="experimentControlsForm"
                  [currentValue]="
                    experimentControlsForm?.controls[specGainBField.key]?.value
                  "
                  legendStyle="small"
                  size="small"
                ></app-radio-button>
              </div>
              <div class="card">
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="integrationTimeCField"
                  [minValue]="minIntegrationTime"
                  [maxValue]="maxIntegrationTime"
                  [step]="integrationTimeStep"
                ></app-number-form-field>
                <app-radio-button
                  id="gain-radio-c"
                  [field]="specGainCField"
                  [parentForm]="experimentControlsForm"
                  [currentValue]="
                    experimentControlsForm?.controls[specGainCField.key]?.value
                  "
                  legendStyle="small"
                  size="small"
                ></app-radio-button>
              </div>
              <div class="card">
                <app-number-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="integrationTimeDField"
                  [minValue]="minIntegrationTime"
                  [maxValue]="maxIntegrationTime"
                  [step]="integrationTimeStep"
                ></app-number-form-field>
                <app-radio-button
                  id="gain-radio-d"
                  [field]="specGainDField"
                  [parentForm]="experimentControlsForm"
                  [currentValue]="
                    experimentControlsForm?.controls[specGainDField.key]?.value
                  "
                  legendStyle="small"
                  size="small"
                ></app-radio-button>
              </div>
            </div>
            @if (fluorescenceChannelsError()) {
              <div class="error" role="alert" aria-live="assertive">
                <span>Error: </span>{{ fluorescenceChannelsError()!.message }}
              </div>
            }
            @if (fluorescenceChannels()?.length > 0) {
              <div class="select--container">
                <app-underlined-dropdown-form-field
                  [parentForm]="experimentControlsForm"
                  [field]="fluorescenceChannelsField"
                ></app-underlined-dropdown-form-field>
              </div>
            }
            @if (selectedFluorescenceChannels()?.length === 0) {
              <div class="warning">
                <mat-icon>warning</mat-icon>
                <p>
                  Warning: No channels selected, fluorescence spectra will still
                  be recorded
                </p>
              </div>
            } @else if (selectedFluorescenceChannels()?.length > 0) {
              <div class="channels-grid">
                @for (
                  channel of selectedFluorescenceChannels();
                  track channel.memorySlot
                ) {
                  <app-fluorescence-channel-card
                    [channel]="channel"
                    [displayButton]="true"
                    (buttonClicked)="removeFluorescenceChannel($event)"
                  ></app-fluorescence-channel-card>
                }
              </div>
            }
          </mat-expansion-panel>
          <mat-expansion-panel
            [expanded]="useSparging()"
            [disabled]="!useSparging()"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">Sparging</div>
              </mat-panel-title>
              @if (!useSparging()) {
                <mat-panel-description
                  >Module not selected</mat-panel-description
                >
              } @else {
                <mat-panel-description>
                  Airflow rate set after device calibrations have been selected
                </mat-panel-description>
              }
            </mat-expansion-panel-header>
            <div class="sparging-grid">
              <div class="button-header">
                <app-mat-outlined-button
                  label="Copy A to B, C, D"
                  ariaLabel="Copy A to B, C, D"
                  buttonId="sparging-copy-btn"
                  id="sparging-copy-btn"
                  iconName="content_copy"
                  iconPosition="left"
                  (buttonClicked)="copySpargingValues()"
                  [isDisabled]="
                    !(currentUser().role
                      | roleCheck: editAccessRoles)
                  "
                ></app-mat-outlined-button>
              </div>
              <div class="sparging-card">
                <app-radio-button
                  id="sparging-radio-a"
                  [field]="spargingControlTypeAField"
                  [parentForm]="experimentControlsForm"
                  [currentValue]="
                    experimentControlsForm?.controls[
                      spargingControlTypeAField.key
                    ]?.value
                  "
                  legendStyle="small"
                  size="small"
                ></app-radio-button>
              </div>
              <div class="sparging-card">
                <app-radio-button
                  id="sparging-radio-b"
                  [field]="spargingControlTypeBField"
                  [parentForm]="experimentControlsForm"
                  [currentValue]="
                    experimentControlsForm?.controls[
                      spargingControlTypeBField.key
                    ]?.value
                  "
                  legendStyle="small"
                  size="small"
                ></app-radio-button>
              </div>
              <div class="sparging-card">
                <app-radio-button
                  id="sparging-radio-c"
                  [field]="spargingControlTypeCField"
                  [parentForm]="experimentControlsForm"
                  [currentValue]="
                    experimentControlsForm?.controls[
                      spargingControlTypeCField.key
                    ]?.value
                  "
                  legendStyle="small"
                  size="small"
                ></app-radio-button>
              </div>
              <div class="sparging-card">
                <app-radio-button
                  id="sparging-radio-d"
                  [field]="spargingControlTypeDField"
                  [parentForm]="experimentControlsForm"
                  [currentValue]="
                    experimentControlsForm?.controls[
                      spargingControlTypeDField.key
                    ]?.value
                  "
                  legendStyle="small"
                  size="small"
                ></app-radio-button>
              </div>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">Notes</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="notes--container">
              <app-underlined-textarea-field
                [parentForm]="experimentControlsForm"
                [field]="noteField"
                [minLength]="notesMinLength"
                [maxLength]="notesMaxLength"
                rows="4"
                [showCharacterCounter]="true"
              ></app-underlined-textarea-field>
            </div>
          </mat-expansion-panel>
          <mat-expansion-panel expanded>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="expansion-header">History</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div id="history--container">
              <table mat-table [dataSource]="changelogList()">
                <ng-container matColumnDef="date">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    (click)="onSort('CreatedAt')"
                    (keydown.enter)="onSort('CreatedAt')"
                    [class.active]="currentSort().sortBy === 'CreatedAt'"
                    [attr.aria-sort]="
                      currentSort().sortBy === 'CreatedAt'
                        ? currentSort().sortDirection === 'asc'
                          ? 'ascending'
                          : 'descending'
                        : 'none'
                    "
                    tabindex="0"
                    role="columnheader"
                  >
                    <span class="sortable">
                      Date
                      <span class="sort-icons" aria-hidden="true">
                        <mat-icon>arrow_drop_up</mat-icon>
                        <mat-icon>arrow_drop_down</mat-icon>
                      </span>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let log">
                    {{ log.createdAt | date: "dd/MM/y - h:mm a" }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="note">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    (click)="onSort('NoteText')"
                    (keydown.enter)="onSort('NoteText')"
                    [class.active]="currentSort().sortBy === 'NoteText'"
                    [attr.aria-sort]="
                      currentSort().sortBy === 'NoteText'
                        ? currentSort().sortDirection === 'asc'
                          ? 'ascending'
                          : 'descending'
                        : 'none'
                    "
                    tabindex="0"
                    role="columnheader"
                  >
                    <span class="sortable">
                      Note
                      <span class="sort-icons" aria-hidden="true">
                        <mat-icon>arrow_drop_up</mat-icon>
                        <mat-icon>arrow_drop_down</mat-icon>
                      </span>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let log">{{ log.noteText }}</td>
                </ng-container>

                <ng-container matColumnDef="change">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    (click)="onSort('ChangeText')"
                    (keydown.enter)="onSort('ChangeText')"
                    [class.active]="currentSort().sortBy === 'ChangeText'"
                    [attr.aria-sort]="
                      currentSort().sortBy === 'ChangeText'
                        ? currentSort().sortDirection === 'asc'
                          ? 'ascending'
                          : 'descending'
                        : 'none'
                    "
                    tabindex="0"
                    role="columnheader"
                  >
                    <span class="sortable">
                      Logged Change
                      <span class="sort-icons" aria-hidden="true">
                        <mat-icon>arrow_drop_up</mat-icon>
                        <mat-icon>arrow_drop_down</mat-icon>
                      </span>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let log">{{ log.changeText }}</td>
                </ng-container>

                <ng-container matColumnDef="user">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    (click)="onSort('CreatedBy')"
                    (keydown.enter)="onSort('CreatedBy')"
                    [class.active]="currentSort().sortBy === 'CreatedBy'"
                    [attr.aria-sort]="
                      currentSort().sortBy === 'CreatedBy'
                        ? currentSort().sortDirection === 'asc'
                          ? 'ascending'
                          : 'descending'
                        : 'none'
                    "
                    tabindex="0"
                    role="columnheader"
                  >
                    <span class="sortable">
                      User
                      <span class="sort-icons" aria-hidden="true">
                        <mat-icon>arrow_drop_up</mat-icon>
                        <mat-icon>arrow_drop_down</mat-icon>
                      </span>
                    </span>
                  </th>
                  <td mat-cell *matCellDef="let log">{{ log.createdBy }}</td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="changelogDisplayedColumns"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: changelogDisplayedColumns"
                ></tr>
                <tr *matNoDataRow>
                  <td [attr.colspan]="4" id="empty-state">
                    <mat-icon id="empty-state--icon">article</mat-icon>
                    <p id="empty-state--title">
                      {{
                        changelogError()
                          ? changelogError().message
                          : "No Changelogs"
                      }}
                    </p>
                  </td>
                </tr>
              </table>
              <div id="pagination--container">
                <app-dropdown-form-field
                  id="changelogs-per-page"
                  [field]="changeLogsPerPageField"
                  [parentForm]="paginationControls"
                ></app-dropdown-form-field>
                <div id="pagination--controls">
                  <app-icon-button
                    iconName="chevron_left"
                    buttonId="previous"
                    ariaLabel="Previous page"
                    (buttonClicked)="getPrevious()"
                    [isDisabled]="!hasPrevious()"
                  ></app-icon-button>
                  <span> {{ currentPage() }} / {{ totalPages() }} </span>
                  <app-icon-button
                    iconName="chevron_right"
                    buttonId="next"
                    ariaLabel="Next page"
                    (buttonClicked)="getNext()"
                    [isDisabled]="!hasNext()"
                  ></app-icon-button>
                </div>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </form>
    </div>
    <div id="button--container">
      <app-button
        label="reset"
        buttonId="reset-btn"
        buttonStyle="yellow"
        [isDisabled]="draftIsLocked() || !hasEditAccess()"
        (buttonClicked)="resetForm()"
      ></app-button>
      <div id="button--container-right">
        <app-button
          label="save"
          buttonId="save-btn"
          [isProcessing]="isProcessing()"
          [isDisabled]="
            isProcessing() ||
            deleteIsProcessing() ||
            draftIsLocked() ||
            !hasEditAccess() ||
            experimentControlsForm.invalid ||
            (experimentControlsForm.pristine && moduleSelectForm.pristine)
          "
          (buttonClicked)="handleSubmit()"
        ></app-button>
        <app-button
          label="next"
          buttonId="next-btn"
          buttonStyle="positive"
          [isDisabled]="
            nextButtonDisabled() ||
            !experimentControlsForm.pristine ||
            !moduleSelectForm.pristine
          "
          (buttonClicked)="onNext()"
        ></app-button>
      </div>
    </div>
  </div>
} @else if (!laboratory() && !getExperimentError()) {
  <app-error-page
    title="You are not a member of this lab"
    primaryText="Sorry, you cannot access this page unless you are a member of a lab"
  ></app-error-page>
} @else {
  <app-error-page
    [primaryText]="getExperimentError()?.message"
  ></app-error-page>
}
<app-modal
  id="create-experiment"
  modalStyle="success"
  titleText="Draft saved"
  primaryText="Experiment draft created.  Do you want to select devices now?"
  buttonLayout="double-button"
  primaryButtonText="next"
  primaryButtonId="next-button"
  secondaryButtonText="close"
  secondaryButtonId="close-create-button"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="update-experiment"
  modalStyle="success"
  titleText="Success"
  primaryText="Experiment updated."
  buttonLayout="double-button"
  primaryButtonText="next"
  primaryButtonId="next-button"
  secondaryButtonText="close"
  secondaryButtonId="close-update-button"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="error"
  modalStyle="error"
  titleText="Error"
  [primaryText]="error()?.message"
  primaryButtonText="close"
  primaryButtonId="close-error-button"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="attention"
  modalStyle="warning"
  titleText="Attention"
  primaryText="Your changes have not been saved. Press cancel to return to the form and save your changes, or continue to discard."
  buttonLayout="double-button"
  primaryButtonText="Continue"
  primaryButtonId="confirm-navigation"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-button"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-modal
  id="device-warning"
  modalStyle="warning"
  titleText="Attention"
  primaryText="This module is not supported on one or more of your devices. If you choose this module your devices will be deleted and you will need to select new devices."
  primaryButtonText="close"
  primaryButtonId="close-device-warning-button"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-modal>
<app-validation-modal
  id="delete-draft"
  titleText="Delete draft?"
  validationText="delete"
  primaryButtonText="Confirm delete"
  primaryButtonId="confirm-delete-button"
  (modalButtonClicked)="deleteDraft()"
  secondaryButtonText="Cancel"
  secondaryButtonId="cancel-delete-button"
  [error]="deleteError()"
></app-validation-modal>
<app-modal
  id="delete-success"
  titleText="Success"
  primaryText="Experiment draft was deleted."
  primaryButtonText="Go to dashboard"
  primaryButtonId="delete-success-button"
  modalStyle="success"
  (modalButtonClicked)="modalButtonClicked($event)"
  [allowClose]="false"
></app-modal>
<app-modal
  id="delete-error"
  titleText="Unable to delete draft"
  [primaryText]="deleteError()?.message"
  primaryButtonText="Close"
  primaryButtonId="error-primary-button"
  modalStyle="error"
  (modalButtonClicked)="modalButtonClicked($event)"
  [allowClose]="false"
></app-modal>
